import type { VoidFunctionComponent } from 'react';
import { BadgeColors, TooltipContent } from '../../../generic';
import TooltipBadge from '../../../generic/Badge/TooltipBadge';

type Props = {
  cve: string;
  showTooltip?: boolean;
};

/**
 * Displays a CVE badge.
 */
const CVEBadge: VoidFunctionComponent<Props> = ({ cve, showTooltip }) => (
  <TooltipBadge
    id="cve-badge"
    tooltip={<TooltipContent>CVE for the vulnerability</TooltipContent>}
    showTooltip={showTooltip}
    color={BadgeColors.White}
  >
    {cve}
  </TooltipBadge>
);

export default CVEBadge;
